import { render, staticRenderFns } from "./EButton.vue?vue&type=template&id=72e71020&"
import script from "./EButton.vue?vue&type=script&lang=js&"
export * from "./EButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports